export default __webpack_public_path__ + "static/custom-ee64ef9d9209e9590857d0d515f07728.png";